export const selectPipeline = (state: {pipeline?: string}) => state.pipeline;
